import { MAIN_URL } from './api';

// Helper to convert storage paths to full Laravel storage URLs
export const getImageUrl = (url: string | null | undefined): string => {
  if (!url) {
    return '';
  }
  
  // If it's already a data URL, return as-is
  if (url.startsWith('data:')) {
    return url;
  }
  
  // If it's already a full URL (starts with http), return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // If it's a relative path starting with /storage, convert to full Laravel URL
  if (url.startsWith('/storage/')) {
    return `${MAIN_URL}${url}`;
  }
  
  // Handle Windows local paths like D:\Work\shalimar\public\storage\uploads\logo\...
  // Convert them to full Laravel storage URLs
  if (url.includes('\\') || /^[a-zA-Z]:/.test(url)) {
    // Extract the path after 'storage\uploads' or 'storage/uploads'
    const normalizedPath = url.replace(/\\/g, '/');
    const storageMatch = normalizedPath.match(/\/storage\/(uploads\/.+)$/);
    if (storageMatch) {
      return `${MAIN_URL}/storage/${storageMatch[1]}`;
    }
    // Try to match just uploads folder
    const uploadsMatch = normalizedPath.match(/\/(uploads\/.+)$/);
    if (uploadsMatch) {
      return `${MAIN_URL}/storage/${uploadsMatch[1]}`;
    }
  }
  
  // If it's a path without leading slash, add /storage/ prefix
  if (!url.startsWith('/')) {
    return `${MAIN_URL}/storage/${url}`;
  }
  
  // Default: prepend MAIN_URL
  return `${MAIN_URL}${url}`;
};
